/**
 * created by li si yi
 * 网站稿件待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import Photos from "../../../../mediaRelease/mediaJump/photos/photos";
import BaseComponent from "../../../../../base/BaseComponent";

class WebNews extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    data = {};

    //判断类型
    isSupport(data) {
        this.data = data;
        // console.log("webNews----------", data);
        if (this.data
            && this.data.data
            && this.data.data.mediaId
            && this.data.data.id
            && this.data.activitiCategoryKey === "webNews"
            && !(this.data.data.atlasList && this.data.data.atlasList.length)
        ) {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'WebsiteIcon';
        return icon
    };
    //刷新回调
    handle = (data, call) => {
        this.editStory(data.data.id, data);
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                // console.log("-------1--请求刷新父页面----------");
                call && call()
            }
        }, "ManuscriptsSubmitted");
        if (call) {
            call();
        }
    };

    //点击标题进入稿件编辑器
    editStory(id, record) {
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
        let webEditorConfig = this.sysConfigGetValueByKey("editor.config.web", "");
        try {
            webEditorConfig = JSON.parse(activitiConfName);
        } catch (e) {
            console.log(e.toString())
        }
        let treeId = record.data.treeId;
        let mediaId = record.data.mediaId;
        let contentId = record.data.contentId;
        let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn = noPublishConfig.indexOf(record.statusName) > -1 ?false  : true
        mustNotShowPublishBtn = false; // 这个判断在编辑器里面已经执行了，外层不用再执行，稿件发布后这个参数就不对了（在不退出编辑器的情况下）。这里应该做的是当前稿件当前人永远不能发布的情况。
        const editorWindow = window.openEditById({
            configName: webEditorConfig?.configName ? webEditorConfig?.configName : "webEditor",
            id: id, params: {
                activitiConfName,
                treeId,
                mediaId,
                contentId,
                storyType: "default",
                checkMainColumn: true,
                mustNotShowPublishBtn
            }
        });
        this.state.editorWindow = editorWindow;
    };

    render() {
        return (
            <div style={{display: 'none'}}>
                <Photos ref={ref => this.photos = ref}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(WebNews)